<template>
  <div id="app">

    <!-- First page: Home -->
    <!-- <HomePage
      v-if="currentPage === 'home'"
      @validated="goToTerms_Condition"
    /> -->
      <!-- NEW ADDITION: Campaign Status Conditional Wrapper for Home Page -->
    <div v-if="currentPage === 'home'">
      <!-- Loading Indicator -->
      <div v-if="loading" class="text-center py-5">
        <p></p>
      </div>

      <!-- Closed Campaign Message -->
      <div v-else-if="!isCampaignActive" class="closed-container">
        <div class="closed-card">
          <h2>Notice</h2>
          <p class="status-message">{{ campaignMessage }}</p>
          <p class="sub-text">Thank you for your interest. This campaign is no longer accepting entries.</p>
        </div>
      </div>

      <!-- Active Home Page -->
      <HomePage
        v-else
        @validated="goToTerms_Condition"
      />
    </div>

    <!-- Terms & Conditions page -->
    <TermsCondition
      v-else-if="currentPage === 'Termscondition'"
      @validated="goToPurchase"
    />

    <!-- Purchase Details -->
    <PurchaseDetails
      v-if="currentPage === 'purchase'"
      @validated="goToCustomer"
      @go-back="currentPage = 'Termscondition'"
    />

    <!-- Customer Details -->
    <CustomerDetails
      v-else-if="currentPage === 'customer'"
      :customer="customerDetails"
      @validated="goToGift"
      @go-back="currentPage = 'purchase'"
    />

 
    <GiftSelection
      v-else-if="currentPage === 'gift'"
      :product="selectedProduct"
      :manualSKU="customerDetails.selectedSKU === 'Other' ? customerDetails.manualMatressCode : ''"
      :quantity="selectedQty"
      :customer="customerDetails"
      @go-back="currentPage = 'customer'"
      @validated="goToEdit"
    />


    <EditDetails
      v-else-if="currentPage === 'edit'"
      :customer="customerDetails"
      :selectedGift="selectedGift"
      @go-back="currentPage = 'gift'"
      @go-back-to-first-page="currentPage = 'home'"
    />
  

  </div>
</template>

<script>
import axios from "axios";
import HomePage from "./views/home.vue"; 
import TermsCondition from "./views/Termscondition.vue"; 
import PurchaseDetails from "./views/PurchaseDetails.vue";
import CustomerDetails from "./views/CustomerDetails.vue";
import GiftSelection from "./views/GiftSelection.vue";
import EditDetails from "./views/editDetails.vue";

export default {
  name: "App",
  components: { HomePage, TermsCondition, PurchaseDetails, CustomerDetails, GiftSelection, EditDetails },
  data() {
    return {
      loading: true,            // NEW ADDITION
      isCampaignActive: true,   // NEW ADDITION
      campaignMessage: "",      // NEW ADDITION
      currentPage: "home", 
      selectedProduct: null,  
      selectedQty: 1,
      customerDetails: {
        customerName: "",
        address1: "",
        address2: "",
        pincode: "",
        city: "",
        state: "",
        customerMobile: "",
        productSerialNo: "",
        productName: "",
        mattressCode: "",
        selectedGift: null, 
        selectedSKU: null,       
        manualMatressCode: '',   
      },
    };
  },
   mounted() {
    this.checkCampaignStatus();
  },


  methods: {
     // NEW ADDITION: Add it here at the top of your methods
    async checkCampaignStatus() {
      try {
        const response = await axios.post("https://loyalty.elevatozrewards.com/wp-json/el/v1/auth/campaignManage");
        if (response.data && response.data.response) {
          const statusData = response.data.response;
          this.isCampaignActive = statusData.is_active;
          this.campaignMessage = statusData.message;
        }
      } catch (error) {
        console.error("Failed to fetch campaign status:", error);
      } finally {
        this.loading = false;
      }
    },
    goToTerms_Condition() {
      this.currentPage = "Termscondition";
    },
    goToPurchase() {
      this.currentPage = "purchase";
    },
    goToCustomer({ quantity, customerMobile, productSerialNo, productName, productSKU , manualMatressCode}) {
      
      this.selectedProduct = {
          tmp_SKU_code: productSKU,     
          name: productName,
          displayCode: productSKU
      };


      this.selectedQty = Number(quantity);

      this.customerDetails = {
        ...this.customerDetails,
        customerMobile,
        productSerialNo,
        productName,
        productSKU,
        manualMatressCode: manualMatressCode || '' 
      };

      this.currentPage = "customer"; 
    },
    goToGift(customer) {
      this.customerDetails = {
        ...this.customerDetails,
        ...customer
      };
      this.currentPage = "gift";
    },
    
   
    goToEdit(validatedCustomer) {

       this.customerDetails = {
        ...this.customerDetails,
        ...validatedCustomer,
        productName: validatedCustomer.productName,
        mattressCode: validatedCustomer.mattressCode
      };

              this.selectedGift = validatedCustomer.selectedGift; 
              this.currentPage = "edit";
   },


    goToFirstPage() {
      this.currentPage = "home";
      this.selectedProduct = null;
      this.selectedQty = 1;
      this.customerDetails = {
        customerName: "",
        address1: "",
        address2: "",
        pincode: "",
        city: "",
        state: "",
        customerMobile: "",
        productSerialNo: "",
        productName: "",
        mattressCode: ""
      };
    }
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: 'Poppins', sans-serif;
  background: #f6f6f6;
}
#app {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
}
</style>
